import { useNotificationContext } from "../../Contexts/NotificationContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import NoNotification from "../../Components/NoNotification";
import { useSignalR } from "../../Contexts/SignalRContext";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from "../../Components/ScrollBar";
import { notifIcons } from "../../utilities/values";
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import dayjs from "dayjs";

function List() {

  const navigate = useNavigate();

  const {
    invokeMethod,
    setNotifications,
    notifications
  } = useSignalR();

  const {
    setNotifsCopy,
    notifsCopy
  } = useNotificationContext();

  const handleBack = () => {
    navigate(-1);
  };

  const renderIndicator = (item) => {
    let indicator = null;
    if (!item.isRead) {
      indicator = (
        <span className="w-[8px] h-[8px] rounded bg-[#db5454] mr-1" />
      );
    }
    return indicator;
  };

  const renderTitleClassname = (item) => {
    let className = "line-clamp-[1]";
    if (!item.isRead) {
      className = "line-clamp-[1] font-bold";
    }
    return className;
  };

  const renderNotifIcon = (item) => {
    let icon = null;
    if (notifIcons[item.type]) {
      icon = (
        <img
          alt="Notification Icon"
          src={notifIcons[item.type]}
          width="100%"
        />
      );
    }
    return icon;
  };

  const renderDate=(dt)=>{
    let date = null;
    if(dt){
      let current = dayjs().startOf('day');
      let notifDate = dayjs(dt).startOf('day');
      if(notifDate.isSame(current)){
        date = dayjs(dt).format("h:mm A");
      }else{
        date = dayjs(dt).format("MMMM DD, YYYY h:mm A");
      }
    }

    return date;
  }

  const handleViewNotif = async(item) => {
    try {
      await invokeMethod("ReadNotification", item.notificationId);
      const updatedItems = notifications.map(e =>
        e.notificationId === item.notificationId ? { ...e, isRead: true } : e
      );
      setNotifications(updatedItems);
      setNotifsCopy(updatedItems);
    } catch (error) {
      console.log('Error updating notification read status');
    } finally {
      navigate("/notification/details", { state: item });
    }
  };

  const handleReadAll=async()=>{
    try {
      await invokeMethod("ReadAllNotifications");
      setNotifications([]);
      invokeMethod("GetNotifications");
    } catch (error) {
      console.log('Error updating all notification read status');
    }
  }

  let notifList = null;

  if (notifsCopy.length>0) {
    notifList = (
      <div className="p-4">
        {notifsCopy.map((item) => {
          return (
            <button
              key={item.notificationId}
              className="flex w-full p-3 border rounded-md text-left mt-4 hover:scale-102 transition-all"
              onClick={() => handleViewNotif(item)}
            >
              <div className="w-10 mr-3">{renderNotifIcon(item)}</div>
              <div className="flex-1">
                <div className="flex items-center">
                  {renderIndicator(item)}
                  <p className={renderTitleClassname(item)}>{item.subject}</p>
                </div>
                <p className="line-clamp-[1] text-[#383f49] text-[14px] my-1">
                  {parse(item.message)}
                </p>
                <p className="text-[#60656d] text-[12px]">
                  {renderDate(item.dateTime)}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    );

  } else {
    notifList = <NoNotification />;
  }

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:my-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="flex flex-row p-4">
            <KeyboardArrowLeftIcon
              className="cursor-pointer mr-2"
              onClick={handleBack}
            />
            <div className="text-md font-bold flex-grow">Notifications</div>
            {
              notifsCopy.length>0?
              <button onClick={handleReadAll} className="text-sm text-gray-500 ml-auto hover:underline">
                Mark all as read
              </button>
              :null
            }
          </div>
          <ScrollArea.Root className="w-full overflow-hidden">
            <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-57px)] sm:h-full sm:max-h-[600px] rounded">
              {notifList}
            </ScrollArea.Viewport>
            <ScrollBar />
          </ScrollArea.Root>
        </div>
      </div>
    </div>
  );
}

export default List;
